import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';

const ButtonTranscriptionSkeleton = () => {
    const { i18next } = useAppContext();

    return (
        <div className="relative flex h-10 shrink-0 items-center gap-1 rounded bg-gray-200 px-2">
            <Icon iconKey="article" size="1.25rem" className="invisible" />
            <span className="invisible text-xs antialiased">
                {i18next.t('ai.transcript.transcribe_call')}
            </span>
            <div className="animate-fade darken-5 absolute inset-x-2 inset-y-2 rounded" />
        </div>
    );
};

export default ButtonTranscriptionSkeleton;
